var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4288",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1H31.5001V32H0.5V1Z",
    fill: "white",
    stroke: "#000000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0038 20.7149C13.2282 20.7149 10.9781 18.4355 10.9781 15.6239V12.0994C10.9781 9.28777 13.2282 7.00845 16.0038 7.00845C18.7795 7.00845 21.0294 9.28777 21.0294 12.0994V15.6239C21.0294 18.4355 18.7795 20.7149 16.0038 20.7149Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9966 9.92501C16.0139 9.92501 16.0281 9.9391 16.0281 9.95658C16.0281 9.97397 16.014 9.98808 15.9966 9.98808C15.9791 9.98808 15.965 9.97397 15.965 9.95658C15.965 9.9391 15.9792 9.92501 15.9966 9.92501Z",
    fill: "black",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7064 26.0155C19.7064 26.0155 17.9493 29.9117 13.7281 29.9117",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9711 12.12H10.0236C9.30119 12.12 8.71558 12.7056 8.71558 13.4281V16.1537C8.71558 16.8762 9.30119 17.4618 10.0236 17.4618C10.4751 17.4618 10.8733 17.233 11.1083 16.885",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0153 12.12H21.9629C22.6853 12.12 23.2709 12.7056 23.2709 13.4281V16.1537C23.2709 16.8762 22.6853 17.4618 21.9629 17.4618C21.5113 17.4618 21.1133 17.233 20.8781 16.885",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6984 4.04291C13.6364 3.82971 13.6031 3.60423 13.6031 3.37103C13.6031 2.04497 14.6782 0.969971 16.0042 0.969971C17.3303 0.969971 18.4053 2.04497 18.4053 3.37103C18.4053 3.60429 18.372 3.82978 18.3101 4.04298",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8677 21.9734C18.8677 21.9734 17.4768 27.909 10.0461 28.1981C9.74963 28.2096 9.51487 28.4531 9.51563 28.7498L9.52344 32.0312",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.755 4.71138C18.6578 4.04895 17.3719 3.66782 15.9969 3.66782C11.9755 3.66782 8.71558 6.92769 8.71558 10.9491V13.4273",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2731 13.4274V10.9491C23.2731 9.04893 22.5453 7.3188 21.3531 6.02231",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4844 24.5758L22.4781 22.0885",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4911 32.0312L22.4781 26.6178",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4281 28.7595V31.4647C5.4281 31.769 5.67485 32.0312 5.97922 32.0312H26.0131C26.3174 32.0312 26.5643 31.769 26.5643 31.4647V25.2592C26.5619 23.4451 25.0809 21.9767 23.2668 21.9789L20.2449 21.9803H18.8766C18.7244 21.9803 18.6011 21.857 18.6011 21.7048V20.016",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4147 20.1611V21.705C13.4147 21.8573 13.2912 21.9807 13.139 21.9805L11.7708 21.9802L8.72548 21.9792C6.91148 21.9768 5.4304 23.4455 5.4281 25.2594V26.6179",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndian);
export default __webpack_public_path__ + "static/media/indian.e8f47c6ac1794e20f0028a3001ee96d4.svg";
export { ForwardRef as ReactComponent };